import React from 'react';
import { Button } from 'react-bootstrap';
import { Icon } from '../';
import PropTypes from 'prop-types';
AtomButton.PropTypes = {
  text: PropTypes.string,
  bsPrefix: PropTypes.string,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  onClick: PropTypes.any,
  type: PropTypes.oneOf(['primary']),
  icon: PropTypes.string,
  iconClassName: PropTypes.string,
  iconStyle: PropTypes.object,
  boxShadow: PropTypes.bool,
  style: PropTypes.any,
};
AtomButton.defaultProps = {
  text: 'submit',
  bsPrefix: 'default-btn',
  className: null,
  disabled: false,
  onClick: null,
  type: null,
  icon: null,
  iconClassName: null,
  iconStyle: null,
  boxShadow: false,
  style: {}
};
function AtomButton(props) {
  let className = '';
  if (props.type === 'primary') {
    className += ' default-btn-cancel';
  }

  if (props.boxShadow === true) {
    className += ' btn-box-shadow';
  }

  // code color backoffice
  if (props.className !== null) {
    className = className + ' ' + props.className;
  }

  function viewIcon() {
    if (props.icon !== null) {
      const iconClassName = 'default-icon-btn';
      return (
        <Icon
          icon={props.icon}
          size={'16px'}
          style={props.iconStyle}
          className={iconClassName + ' ' + props.iconClassName}
        />
      );
    }
    return null;
  }
  return (
    <Button
      bsPrefix={props.bsPrefix}
      className={className}
      disabled={props.disabled}
      onClick={props.onClick}
      style={props.style}
    >
      {!props.iconRight && viewIcon()}
      {props.text}
      {props.iconRight && viewIcon()}
    </Button>
  );
}
export default AtomButton;
